import type { DataTableHeader } from '@/types/vuetify';

export function createCustomLeaguesPageHeaders(): DataTableHeader[] {
    const { t } = useI18n();

    return [
        {
            title: t('customLeagues.name'),
            value: 'name',
            key: 'name',
            align: 'start',
            sortable: true,
            nowrap: true,
            minWidth: 220,
            headerProps: { class: 'nowrap' },
        },
        {
            title: t('customLeagues.sport'),
            value: 'sportId',
            key: 'sportId',
            align: 'start',
            sortable: false,
            nowrap: true,
            minWidth: 100,
            width: 100,
            headerProps: { class: 'nowrap' },
        },
        {
            title: t('customLeagues.limits'),
            value: 'limitsCategoryId',
            key: 'limitsCategoryId',
            align: 'start',
            sortable: false,
            nowrap: true,
            headerProps: { class: 'nowrap' },
        },
        {
            title: t('customLeagues.market'),
            value: 'marketCategoryId',
            key: 'marketCategoryId',
            align: 'start',
            sortable: false,
            nowrap: true,
            headerProps: { class: 'nowrap' },
        },
        {
            title: t('customLeagues.country'),
            value: 'countryId',
            key: 'countryId',
            align: 'start',
            sortable: false,
            nowrap: true,
            headerProps: { class: 'nowrap' },
        },
        {
            title: t('customLeagues.category'),
            value: 'categoryId',
            key: 'categoryId',
            align: 'start',
            sortable: false,
            nowrap: true,
            headerProps: { class: 'nowrap' },
        },
        {
            title: t('customLeagues.age'),
            value: 'ageCategoryId',
            key: 'ageCategoryId',
            align: 'start',
            sortable: false,
            nowrap: true,
            headerProps: { class: 'nowrap' },
        },
        {
            title: t('customLeagues.gender'),
            value: 'gender',
            key: 'gender',
            align: 'start',
            sortable: false,
            nowrap: true,
            headerProps: { class: 'nowrap' },
        },
        {
            title: t('customLeagues.minute'),
            value: 'minute',
            key: 'minute',
            align: 'end',
            sortable: false,
            nowrap: true,
            minWidth: 72,
            width: 72,
            headerProps: { class: 'nowrap' },
        },
        {
            title: t('customLeagues.fixing'),
            value: 'fixing',
            key: 'fixing',
            align: 'center',
            sortable: false,
            nowrap: true,
            minWidth: 72,
            width: 72,
            headerProps: { class: 'nowrap' },
        },
        {
            title: t('customLeagues.tier'),
            value: 'tier',
            key: 'tier',
            align: 'end',
            sortable: false,
            nowrap: true,
            minWidth: 72,
            width: 72,
            headerProps: { class: 'nowrap' },
        },
        {
            title: t('customLeagues.wiki'),
            value: 'wikiLink',
            key: 'wikiLink',
            align: 'start',
            sortable: false,
            nowrap: true,
            headerProps: { class: 'nowrap' },
        },
        {
            title: '',
            value: 'actions',
            key: 'actions',
            align: 'end',
            sortable: false,
            nowrap: true,
            width: 48,
            cellProps: { class: 'pl-0 pr-1' },
            headerProps: { class: 'nowrap' },
        },
    ];
}
